<template>
  <section class="header_wrap" :class="{ 'with-warning': !localIsExtensionInstalled, 'header_wrap--magicone': isMagicOne }">
    <div v-if="!localIsExtensionInstalled" class="extension-warning">
      🚨 확장 프로그램이 아직 설치되지 않았어요! 필요한 기능을 바로 이용하려면 지금 다운로드하세요!
      <a href="https://chromewebstore.google.com/detail/idkahagphdclcilpdofbcapdphnghgli?utm_source=item-share-cb"
         target="_blank"
         @click="startCheckingForExtension">
        <p class="link"> 받으러 가기 ⬇️</p>
      </a>
    </div>

    <div class="side_logo">
      <router-link to="/app" class="logo-text">
        {{ siteName }}
      </router-link>
      <p v-if="isDomesinOnly" class="domaesin_badge">도매의신자동화 계정</p>
    </div>

    <div class="header_content">
      <div class="left_side">
        <div class="expire_date">
          <p class="remainTime" v-html="remainTime.replace(/\n/g, '<br />')"></p>
        </div>
      </div>

      <div class="right_side">
        <div class="greeting" v-if="userName">
          <div class="greeting_content">
            {{ userName }} ({{ displayUserId || 'N/A' }}) 환영합니다. 즐거운 하루 되세요. <br>
            <span v-if="isEmployeeAccount" class="account_type">
              [본계정: {{ mainUserId }} / 직원계정: {{ subUserId }}]
            </span>
            <span v-else class="account_type">
              [본계정: {{ displayUserId || 'N/A' }}]
            </span>
            <span>
              현재 탭 번호 : {{ this.tabId }}
            </span>
            <div v-html="userComment"></div>
          </div>
        </div>




        <div class="version_info" v-if="appVersion">
          <span>v{{ formattedVersion }}</span>
        </div>

        <!-- 매직원은 헤더에서 결제하기를 노출하지 않는다 -->
        <button class="approval" v-if="!isMagicOne">
          <router-link to="/plan/card"> 결제하기</router-link>
        </button>
        <button class="approval">
          <router-link to="/app/addonService"> 부가서비스</router-link>
        </button>
        <button class="balance" @click="openDepositDetail = true">
          <span>포인트</span>
          <p>
            <strong>{{ depositInfo?.deposit.toLocaleString() }}</strong> 원
          </p>
        </button>
        <button class="alert" @click="openAlert()">
          <div class="svg_container">
            <svg_alert />
            <div class="badge count_badge" v-if="unreadAlarmCount > 0">
              {{ unreadAlarmCount > 99 ? '99+' : unreadAlarmCount }}
            </div>
          </div>
          <!--          <div class="svg_container">
                      <svg_work_status />
                      <div class="badge" v-if="!alert && !visitUpload && socketStore.status !== 'WAIT'">
                        .
                      </div>
                    </div>-->
        </button>
        <button class="logout" @click="setLogout">
          <img src="/assets/images/app/layout/logout.svg" alt="logout" title="로그아웃" />
        </button>
      </div>
    </div>

    <Alert v-if="alert" @closeAlert="closeAlert" @updateUnread="count => (unreadAlarmCount = count)" />
    <DepositDetail v-if="openDepositDetail" :depositInfo="depositInfo" @closeDepositDetail="closeDepositDetail"
                   v-click-outside="closeDepositDetail" />

    <!-- ✅ Fix: Pass `removeToast` properly -->
    <PccToast :toastList="toastList" @removeToast="removeToast" />
  </section>
</template>

<script>
import dayjs from 'dayjs';
import Alert from '../components/Alert';
import DepositDetail from '../components/DepositDetail';
import PccToast from '../components/PccToast';
import svg_alert from '@/components/svg/svg_alert';
/*
import svg_work_status from '@/components/svg/svg_work_status';
*/
import { accountAPI } from '@/api'; //dashboardApi
import chromeExAPI from '@/chromeExAPI';
import { getTabId } from '@/packaging/vueWsEcho';
import { getThemeHost } from '@/utils/themeHost';

export default {
  props: {
    isExtensionInstalled: Boolean
  },
  components: {
    Alert,
    DepositDetail,
    PccToast,
    svg_alert
    /*
        svg_work_status
    */
  },
  data() {
    return {
      remainTime: '확인 중입니다.',
      alert: false,
      visitUpload: false,
      depositInfo: null,
      openDepositDetail: false,
      pcc: '',
      receiverName: '',
      receiverTelNo: '',
      toastList: [],
      userName: '',
      userId: '',
      extensionCheckInterval: null,
      localIsExtensionInstalled: this.isExtensionInstalled,
      appVersion: null,
      isEmployeeAccount: false,
      mainUserId: '',
      subUserId: '',
      tabId: '',
      // 관리자 답변 미확인 건수 (알림 뱃지)
      unreadAlarmCount: 0,
      unreadAlarmInterval: null

    };
  },
  created() {
    this.getDepositInfo();
    if (this.$route.query['ResultCode'] === '3001') {
      this.checkPaymentAfter();
    }

    /*
        setInterval(() => this.updateRemainTime(), 1000);
    */
  },
  async mounted() {
    this.checkExtensionStatus();
    const cookieUserName = this.getCookie('userName');
    if (cookieUserName) {
      this.userName = cookieUserName;
    } else {
      const { user } = this.authStore;
      if (user) {
        this.userName = user.userName && user.userName.trim() ? user.userName : '회원';
        this.setCookie('userName', this.userName, 1);
      }
    }

    // userId 설정 (여러 경로에서 시도)
    await this.setUserId();

    // 직원계정 정보 설정
    this.isEmployeeAccount = localStorage.getItem('isEmployeeAccount') === 'true';
    if (this.isEmployeeAccount) {
      this.mainUserId = localStorage.getItem('loginUserId') || '';
      this.subUserId = localStorage.getItem('subUserId') || '';
    }

    // 버전 정보 가져오기
    this.appVersion = this.authStore.version || localStorage.getItem('version');

    this.tabId = getTabId();

    // 관리자 답변 알림 : 진입 시 1회 + 3분 주기로 갱신
    this.loadUnreadAlarmCount();
    this.unreadAlarmInterval = setInterval(this.loadUnreadAlarmCount, 180000);
  },
  beforeDestroy() {
    if (this.extensionCheckInterval) {
      clearInterval(this.extensionCheckInterval);
      this.extensionCheckInterval = null;
    }
    if (this.unreadAlarmInterval) {
      clearInterval(this.unreadAlarmInterval);
      this.unreadAlarmInterval = null;
    }
  },
  computed:{
    isDomesinOnly() {
      // authStore.user 또는 localStorage에서 isDomesinOnly 확인
      const user = this.authStore.user;
      if (user && user.isDomesinOnly) {
        return true;
      }
      try {
        const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        if (storedUser && storedUser.isDomesinOnly) {
          return true;
        }
      } catch (e) {
        // 무시
      }
      return false;
    },
    /** 화면 브랜딩 기준 호스트. 로컬에서는 로그인 화면에서 고른 값이 들어온다. */
    themeHostName() {
      return getThemeHost();
    },
    sideLogoText() {
      const host = this.themeHostName;
      if (host.includes('daenlabs.kr')) return '다엔랩스';
      if (host.includes('connectone07.co.kr')) return '커넥트원';
      if (host.includes('crosssell.co.kr')) return '크로스셀';
      return '오버링크';
    },
    siteName() {
      const host = this.themeHostName;
      if (host.includes('magicone.kr') || host === 'localhost') return '매직원';
      if (host.includes('omarket.kr')) return '셀리오마켓';
      if (host.includes('daenlabs.kr')) return '다엔랩스';
      if (host.includes('connectone07.co.kr')) return '커넥트원';
      if (host.includes('kcode.store')) return '케이코드';
      if (host.includes('crosssell.co.kr')) return '크로스셀';
      if (host.includes('overlink.kr')) return '오버링크';
      if (host.includes('cospia.net')) return '오손업로드';
      if (host.includes('smartcross.kr')) return '스마트크로스';
      return '오버링크';
    },
    isMagicOne() {
      const host = this.themeHostName;
      return host.includes('magicone.kr') || host === 'localhost';
    },
    logoSrc() {
      const host = this.themeHostName;

      if (host === 'localhost') {
        return '/assets/images/common/logo_o.png';
      }

      if (host.includes('omarket.kr')) {
        return '/assets/images/common/logo.png';
      } else if (host.includes('daenlabs.kr')) {
        return '/assets/images/common/logo_s.png';
      } else if (host.includes('kimmanager.co.kr')) {
        return '/assets/images/common/logo_j.png';
      } else if (host.includes('connectone07.co.kr')) {
        return '/assets/images/common/logo_i.png';
      } else if (host.includes('kcode.store')) {
        return '/assets/images/common/logo_m.png';
      } else if (host.includes('crosssell.co.kr')) {
        return '/assets/images/common/logo_c.png';
      } else if (host.includes('overlink.kr')) {
        return '/assets/images/common/logo_o.png';
      } else if (host.includes('zijyasssssell.com')) {
        return '/assets/images/common/logo_z.png';
      } else if (host.includes('cospia.net') || host.includes('magicone.kr')) {
        return '/assets/images/common/logo_os.png';
      } else if (host.includes('smartcross.kr')) {
        return '/assets/images/common/logo_sc.png';
      } else {
        return '/assets/images/common/logo.png';
      }
    }
    ,
    userComment() {
      const host = this.themeHostName;

      if (host.includes('omarket.kr')) {
        return '';
      } else if (host.includes('daenlabs.kr')) {
        return '';
      } else if (host.includes('kimmanager.co.kr')) {
        return '';
      } else if (host.includes('connectone07.co.kr')) {
        return ``;
      } else if (host.includes('kcode.store')) {
        return '';
      } else {
        return ``;
      }
    },
    formattedVersion() {
      if (!this.appVersion) return '';

      // 버전 문자열에서 숫자.숫자.숫자.숫자 패턴까지만 추출
      const match = this.appVersion.match(/^(\d+\.\d+\.\d+\.\d+)/);
      if (match) {
        return match[1];
      }

      // 패턴이 맞지 않으면 원본 반환 (또는 빈 문자열)
      return this.appVersion;
    },
    displayUserId() {
      // data의 userId가 있으면 사용, 없으면 computed로 가져오기
      if (this.userId) return this.userId;
      const user = this.authStore.user;
      if (!user) {
        // localStorage에서도 시도
        try {
          const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
          if (storedUser && storedUser.userId) {
            return String(storedUser.userId).trim();
          }
        } catch (e) {
          // 무시
        }
        return '';
      }
      // userId 필드 확인
      const id = user.userId || user.userAccountId || user.id;
      return id ? String(id).trim() : '';
    }

  },
  methods: {
    updateRemainTime() {
      const user = this.depositInfo;

      const expireDate = user?.endDate;
      const joinDate = user?.joinDate;

      const now = dayjs();
      const join = dayjs(joinDate);
      const expire = dayjs(expireDate);
      const thresholdDate = dayjs('2025-03-26');

      const freePeriod = join.isAfter(thresholdDate.subtract(1, 'day')) ? 21 : 14;
      const freeEnd = join.add(freePeriod, 'day');               // 무료 끝나는 날
      const paidStart = freeEnd;                                 // 유료 시작일

      console.log('유료 시작일 +' + paidStart.format('YYYY-MM-DD').toString());
      const remainingFreeDays = freeEnd.diff(now, 'day');
      const remainingPaidDays =
        /* now.isBefore(paidStart) ?  expire.diff(paidStart, 'day') :*/ expire.diff(now, 'day');
      const remainingPaidTotalHours = expire.diff(now, 'hour');
      const remainingPaidHours = remainingPaidTotalHours % 24;
      const remainTimeStr =
        remainingPaidDays > 0
          ? `${remainingPaidDays}일 ${remainingPaidHours}시`
          : remainingPaidTotalHours > 0
            ? `${remainingPaidTotalHours}시`
            : null;

      if (remainingFreeDays > 0 && now.isBefore(freeEnd) && remainingPaidDays > 0) {
        this.remainTime = `📢 총 사용 기간이 ${remainTimeStr} 남았습니다. (정품소명가능) `;
      } else if (remainingFreeDays <= 0 && remainingPaidDays > 0) {
        this.remainTime = `📢 유료 사용기간이 ${remainTimeStr} 남았습니다. (정품소명가능)`;
      } else if (remainingFreeDays > 0 && remainingPaidDays > 0) {
        // 오늘이 무료 종료일 당일이면 둘 다 보여줄 수 있음
        this.remainTime = `📢 총 사용 기간이 ${remainTimeStr} 남았습니다. (정품소명가능)`;
      } else {
        this.remainTime = '📢 사용 기간이 만료되었습니다.';
      }
    },
    async getDepositInfo() {
      const res = await accountAPI.GetUserRestrics();
      this.depositInfo = res.data;
      this.updateRemainTime();
    },
    openAlert() {
      this.alert = !this.alert;
      this.visitUpload = true;
    },
    closeAlert() {
      this.alert = false;
      // 알림창에서 읽음 처리했을 수 있으니 뱃지를 다시 맞춘다.
      this.loadUnreadAlarmCount();
    },
    // 관리자 답변 미확인 건수 조회 (오류신고 / 관리자문의 공용)
    async loadUnreadAlarmCount() {
      try {
        if (!this.authStore.accessToken) return;
        const res = await errorReportAPI.myUnreadCount();
        if (res?.status === 'Success' && res.data) {
          this.unreadAlarmCount = res.data.unreadCount ?? 0;
        }
      } catch (error) {
        console.warn('[Header] 알림 건수 조회 실패', error);
      }
    },
    closeDepositDetail() {
      this.openDepositDetail = false;
    },
    checkPaymentAfter() {
      this.common.setToast('blue', 'good', '포인트 충전이 완료되었습니다.');
      this.openDepositDetail = true;
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    },
    getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
        if (cookie.indexOf(name + '=') === 0) {
          return cookie.substring(name.length + 1, cookie.length);
        }
      }
      return null;
    },
    deleteCookie(cookieName) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    },
    setLogout() {
      this.authStore.logout();
      this.deleteCookie('userName');
      this.templateStore.clearTemplate();
      this.$router.replace('/user');
    },
    async checkExtensionStatus() {
      this.localIsExtensionInstalled = await chromeExAPI.isExtensionInstalled();
      if (this.localIsExtensionInstalled) {
        clearInterval(this.extensionCheckInterval);
        this.extensionCheckInterval = null;
      }
    },
    startCheckingForExtension() {
      if (this.localIsExtensionInstalled) return;
      if (!this.extensionCheckInterval) {
        this.extensionCheckInterval = setInterval(() => {
          this.checkExtensionStatus();
        }, 1000);
      }
    },
    removeToast(index) {
      this.toastList.splice(index, 1);
    },
    async setUserId() {
      // 1. localStorage에서 로그인 시 저장한 userId 가져오기 (우선순위 1)
      const loginUserId = localStorage.getItem('loginUserId');
      if (loginUserId) {
        this.userId = String(loginUserId).trim();
        return;
      }

      // 2. authStore.user에서 가져오기
      const user = this.authStore.user;
      if (user && user.userId) {
        this.userId = String(user.userId).trim();
        return;
      }

      // 3. localStorage의 user 객체에서 가져오기
      try {
        const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        if (storedUser && storedUser.userId) {
          this.userId = String(storedUser.userId).trim();
          return;
        }
      } catch (e) {
        // 무시
      }

      // 4. authStore에 user가 없으면 setupUser 시도
      if (!user && this.authStore.accessToken) {
        try {
          await this.authStore.setupUser();
          const updatedUser = this.authStore.user;
          if (updatedUser && updatedUser.userId) {
            this.userId = String(updatedUser.userId).trim();
            return;
          }
        } catch (e) {
          console.error('setupUser 실패:', e);
        }
      }

      // 5. 그래도 없으면 빈 문자열
      this.userId = '';
    }
  }

};
</script>


<style lang="scss">
@import '@/assets/style/app/layout/header.scss';

// MagicOne 전용 스타일
.header_wrap--magicone {
  background: #ffffff !important;
  border-bottom: 1px solid #e5e7eb;

  .side_logo {
    .logo-text {
      color: #111827 !important;
      font-weight: 800 !important;
      font-size: 28px !important;
      -webkit-text-fill-color: #111827 !important;
    }
  }

  .header_content {
    color: #111827 !important;

    * {
      color: #111827 !important;
    }
  }

  // 기본 헤더는 어두운 배경 전제라 버튼이 흰 배경 + 흰 테두리다.
  // 흰 헤더에서는 경계가 사라져 안 보이므로 회색 테두리/배경으로 바꾼다.
  .approval {
    background-color: #f9fafb !important;
    border: 1px solid #d1d5db !important;
    border-radius: 6px;
    transition: all 0.15s ease-in-out;

    &:hover {
      background-color: #f3f4f6 !important;
      border-color: #9ca3af !important;
    }
  }

  .balance {
    background-color: #f9fafb !important;
    border: 1px solid #d1d5db !important;
    border-radius: 6px;
  }

  .alert,
  .logout {
    background-color: #f9fafb !important;
    border: 1px solid #d1d5db !important;

    &:hover {
      background-color: #f3f4f6 !important;
      border-color: #9ca3af !important;
    }
  }

  .version_info {
    color: #6b7280 !important;
  }
}
</style>